import Controller from '../modal_controller'
export default Controller